import styled from "styled-components";

import {
  absoluteCenter,
  alignItemsCenter,
  alpha,
  circle,
  clipBorderRadius,
  flexCenter,
  flexColumn,
  flexSpBetween,
  pseudo,
  rem,
  size,
} from "@styles/Utilities.styled";


export const StyledSurgicalHistoryCard = styled.div`
  position: relative;
  ${flexColumn}
  align-self: start;
  min-height: ${rem(250)};
  min-width: ${rem(350)};
  max-width: ${rem(420)};
  padding: 1.5rem 1.5rem 1rem;
  background-color: var(--clr-white);
  border: 1px solid var(--clr-gray-150);
  ${clipBorderRadius("var(--border-radius-3)")}

  .card-header {
    ${flexSpBetween}
    align-items: end;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid var(--clr-gray-175);

    .heading {
      font-size: ${rem(18)};
      font-weight: 500;
    }

    button {
      ${flexCenter}
      ${size(rem(30))}
      border-radius: var(--border-radius-3);
      border: 1px solid var(--clr-gray-175);

      &:hover {
        background-color: var(--clr-accent);
        border-color: rgb(0, 0, 0, 0);

        svg {
          fill: var(--clr-white);
        }
      }

      svg {
        fill: var(--clr-accent);
        ${size("60%")}
      }

      .plus-icon {
        ${size("70%")}
      }
    }
  }

  .empty-label {
    ${absoluteCenter}
    color: var(--clr-gray-400);
    font-size: ${rem(14)};
    text-align: center;
  }

  .timeline {
    ${flexColumn}
    gap: 2rem;
    margin-block: auto;

    &-item {
      ${alignItemsCenter}
      gap: 1rem;

      &:first-child {
        .decor {
          border-color: var(--clr-accent);
        }
      }

      &:last-child {
        .decor::before {
          background: linear-gradient(
            to bottom,
            var(--clr-gray-300),
            rgb(0, 0, 0, 0) 80%
          );
        }
      }

      .date {
        font-size: ${rem(13)};
        color: var(--clr-gray-400);
        width: 7ch;
      }

      .decor {
        position: relative;
        ${circle(rem(15))}
        background-color: var(--clr-white);
        border: 2px solid var(--clr-gray-300);
        z-index: 1;

        &::before {
          ${pseudo}
          overflow: hidden;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          ${size("1px", rem(40))}
          background-color: var(--clr-gray-300);
          z-index: -1;
        }
      }

      .name {
        font-size: ${rem(14)};
      }
    }
  }

  .card-footer {
    ${flexCenter}
    padding-top: 1rem;
    margin-top: auto;
    border-top: 1px solid ${alpha("var(--clr-black)", 0.1)};
  }
`;
